import { Select, Stack, Text } from '@mantine/core';
import { useFormContext } from '../../../contexts/formContext';
import { SettingTitle } from '../../../components/SettingTitle';

const options = [
  {
    label: 'Atlas Baking',
    value: 'rebake',
    description: 'Aggregates all UVs and creates a unified layout, bakes all information to new UVs.',
  },
  {
    label: 'Remeshing (Keep Alpha)',
    value: 'remeshing-keep-alpha',
    description:
      'Same functionality as Atlas Baking method with the addition of utilizing a remeshing process before decimation, which can be beneficial to reach low mesh resolution results and deal with complex input data such as Digital Fashion.',
  },
  {
    label: 'Remeshing (Bake Alpha)',
    value: 'remeshing-bake-alpha',
    description:
      'Same functionality as Remeshing (Keep Alpha) method, but instead of preserving meshes, materials associated with alpha textures, everything gets merged and the opaque parts of the alpha textures gets baked on top of the remeshed surface.',
  },
  {
    label: 'Preserve Tiling',
    value: 'preserveTiling',
    description:
      'Preserves input\'s tiled UVs and textures. Non-tiling UVs will be aggregated and baked as in "Atlas Baking" mode. If ao is enabled will be baked into a new 2nd UV set.',
  },
  {
    label: 'Preserve Mesh & Material Nodes',
    value: 'rebakePreserveNodes',
    description:
      'Preserves all mesh and material nodes. Aggregates all UVs per material and bakes information to these new UVs. Can lead to a high number of output texture maps and draw calls!',
  },
  {
    label: 'Preserve UVs',
    value: 'preserveUVsAndNodes',
    description:
      'Preserves all mesh, material nodes and all input UVs. Process might stop and deliver slightly higher mesh resolution if face or vertices target is very low.',
  },
  {
    label: 'Drop Textures to Material Colors',
    value: 'dropTextures',
    description:
      'Averages the color of input texture maps and converts to material colors. Avoids baking and textures. Results in very low file size, but might produce more draw calls than "Atlas Baking".',
  },
];

const path = 'assetSimplification.meshDecimation.method';

export function AssetSimplificationMode() {
  const form = useFormContext();
  const current = options.find((option) => option.value === form.values.assetSimplification?.meshDecimation?.method);

  const description = `${current?.label || ''} ${current ? '-' : ''} ${current?.description || ''}`.trim();

  return (
    <Stack gap='xs'>
      <SettingTitle
        title='Asset Simplification Mode'
        description='Simplification modes define sets of constraints onto the decimation, by
        preserving certain properties while still being able to decimate.
        "Atlas Baking" is the default and does not apply any
        additional constraints to the decimation.'
      />
      <Select data={options} {...form.getInputProps(path)} />
      <Text c='gray.6'>{description}</Text>
    </Stack>
  );
}
